// Node
const $ = require('jquery');
const { updateProfile } = require('../common/update_profile');
require('inputmask');
import { popupSliderTnsInit } from 'new_design/desktop/common/sliders';
import { tns } from 'tiny-slider/src/tiny-slider';
import { fixBaseMenu, setActiveTab, setNavElementEvents, setNavElementEventsWithFixHeader } from './camps/show/nav';

let inputWrappers = $('.profile_input');
let inputs = $('.profile_input input');
let clearInputIcons = $('.icon-clear');

$(function () {
  window.scrollTo(0, 0);
  toggleClearIcons();

  inputs.on('input focus blur', toggleClearIcons);

  Inputmask({ mask: '+7 (999) 999-99-99', showMaskOnHover: false }).mask($('#login'));

  clearInputIcons.on('mousedown', function (e) {
    e.preventDefault();
    let index = clearInputIcons.index(this);
    inputs.eq(index).val('');
    inputWrappers.eq(index).removeClass('mtui-text-field_filled');
    toggleClearIcons();
  });

  updateProfile();

  $('.menu-aside__item-active').each(function () {
    let icon = $(this).find('.client-menu__item-flex div:first-child');
    let id = $(this).attr('id');
    icon.addClass(`icon-${id}_green icon-${id}_green-dims`);
  });

  $('#client-menu').hover(
    function () {
      $('.link_green').addClass('link_green__hovered');
      $('.header-menu__auth').addClass('header-menu__auth__hovered');
      $('.client-icon .icon').addClass('icon-user_c icon-user_c-dims');
    },
    function () {
      $('.link_green').removeClass('link_green__hovered');
      $('.header-menu__auth').removeClass('header-menu__auth__hovered');
      $('.client-icon .icon').removeClass('icon-user_c icon-user_c-dims');
    }
  );

  $('input[name="pay_option"]').change(updatePayButtonText);
  updatePayButtonText();

  $('.main-form-pay-parts').click(function () {
    $('input[name="payment"]:checked').parent().parent().trigger('click');
  });

  setNavElementEventsWithFixHeader(
    document.querySelectorAll('.page-nav .page-nav__list > .page-nav__list-item'),
    'active',
    $('.page-nav')
  );

  setNavElementEvents(
    document.querySelectorAll('.popup-nav .popup-nav__list > .popup-nav__list-item'),
    'popup-tabs__tab-active'
  );

  fixBaseMenu();
  setActiveTab();

  $('#link-to-routes').click(function () {
    event.preventDefault();
    event.stopPropagation();

    const navHeight = $('.page-nav').outerHeight() - 5;
    const $campRoutes = $('#camp-routes');
    let topPosition;

    if ($('.page-nav').hasClass('fix-nav')) {
      topPosition = $campRoutes.offset().top - navHeight;
    } else {
      topPosition = $campRoutes.offset().top - navHeight * 2;
    }

    window.scrollTo({
      top: topPosition,
      behavior: 'smooth',
    });
  });

  $('#apartment.open_popup').click(function () {
    const popupId = $(this).attr('rel');

    $(`.popup#${popupId} .apartment_modal_lazy`).each(function () {
      const dataSrcValue = $(this).attr('data-src');
      $(this).attr('src', dataSrcValue);
    });

    popupSliderTnsInit();

    $('.popup.room-info').css('display', 'none');
    $(`.popup#${popupId}`).css('display', 'block');
  });

  $('#camp.open_popup').click(function () {
    $('.popup.camp-info').css('display', 'block');
  });

  $('.card__images-container').each(function () {
    const camp_id = $(this).data('camp_id');
    if (camp_id == null) return;
    tns({
      container: $(`#images-slider-${camp_id}`)[0],
      loop: false,
      items: 1,
      nav: false,
      center: false,
      rewind: true,
      autoHeight: false,
      touch: true,
      mouseDrag: false,
      lazyload: true,
      controlsContainer: `#images-controls-${camp_id}`,
      preventScrollOnTouch: 'auto',
    });
  });
});

function toggleClearIcons() {
  inputs.not('[readonly]').each(function (index) {
    if ($(this).val() && $(this).is(':focus')) {
      clearInputIcons.eq(index).show();
    } else {
      clearInputIcons.eq(index).hide();
    }
  });
}

function updatePayButtonText() {
  const selectedValue = $('input[name="pay_option"]:checked').val();
  const labelText = selectedValue === 'full' ? $('.full sub').text() : $('.parts sub').text();
  const buttonText = 'Оплатить ' + labelText;
  $('#payment-btn a.book-payment__btn').text(buttonText);
}
